import MeasurementsContext from "contexts/MeasurementsContext";
import { MeasurementsContextType } from "contexts/MeasurementsContext/MeasurementsContext";
import { useMemo } from "react";

interface MeasurementsProviderProps {
  children?: React.ReactNode;
  deleteById(id: string): Promise<{ id: string } | undefined>;
  deleteVideo: (id: string) => Promise<void>;
  updateCompletedDate(id: string, completedDate: string): Promise<void>;
}

function MeasurementsProvider(props: MeasurementsProviderProps) {
  const { children, deleteById, deleteVideo, updateCompletedDate } = props;

  const contextValue: MeasurementsContextType = useMemo(
    () => [undefined, { deleteById, deleteVideo, updateCompletedDate }],
    [deleteById, deleteVideo, updateCompletedDate]
  );

  return <MeasurementsContext.Provider value={contextValue}>{children}</MeasurementsContext.Provider>;
}

export default MeasurementsProvider;
